import { RouterPaths } from "../routerPaths";
import { importPages } from "../lazyRoute";

const settingsRoutes = [
    {
        path: RouterPaths.PASSWORDPOLICIES,
        element: importPages.PasswordPolicies,
    },
    {
        path: RouterPaths.INSTITUTIONALPREFERENCES,
        element: importPages.InstitutionalPreferences,
    },
];
export default settingsRoutes;
